<template>
  <div>
    <CHeader class="bg-dark position-relative">
      <div class="mt-2"  style="margin: 0 12%;">
        <div style="width:200px !important;">
          <img block
            class="w-100 h-100"
            :src="logoEmpresa" />
        </div>
      </div>
    </CHeader>
    <CContainer>
      <div v-if="isError">
        <h1>Error... {{ message }}</h1>
      </div>
      <CCard class="rounded shadow-sm mt-5 w-50">
        <CCardHeader class="text-center">
          <h2>Cambio de contrase&ntilde;a</h2>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow>
              <CCol>
                <CInput 
                  label="Nueva contraseña" 
                  type="password"
                  placeholder="Contraseña nueva" 
                  addLabelClasses="text-muted font-weight-bold"
                  :value.sync="nuevaClave">
                  <template #prepend-content>
                    <i class="bi bi-key"></i>
                  </template>
                </CInput>
                <CInput 
                  label="Confirmación contraseña" 
                  type="password"
                  placeholder="Confirmacion" 
                  addLabelClasses="text-muted font-weight-bold"
                  :value.sync="confirmacionClave">
                  <template #prepend-content>
                    <i class="bi bi-key"></i>
                  </template>
                </CInput>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CButton 
                  color="primary" 
                  class="col-sm-12" 
                  :disabled="!validateForm" 
                  :class="!validateForm ? 'disabled' : ''" 
                  @click="sendRequestChangePassword()">
                  <i class="bi bi-send mr-2"></i>
                  Enviar
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </CContainer>
    <CElementCover v-show="loading"/>
  </div>
</template>

<script>
  import { getCompanyLogo } from '../general'
  import { asignaNuevaClaveUsuario, validaClaveUsuario } from '../api'

  export default {
    name: "ChangePassword",
    data() {
      return {
        loading: false,
        isError: false,
        message: "",
        logoEmpresa: "",
        uidB64: "",
        token: "",
        nuevaClave: "",
        confirmacionClave: ""
      }
    },
    methods: {
      async validRecoveryPassword(key) {
        try {
          const { errorCode, errorMessage, response } = await validaClaveUsuario(key)

          if (errorCode > 0) {
            this.isError = true
            this.message = errorMessage
          } else {
            this.uidB64 = response.UIDB64
            this.token = response.Token
          }
        } catch(error) {
          this.isError = true
          console.log(error);
        }
      },
      async sendRequestChangePassword() {
        try {
          const { errorCode, errorMessage } = await asignaNuevaClaveUsuario(this.token, this.uidB64, this.nuevaClave)
  
          if (errorCode === 0) {
            this.$router.push("/")
          } else {
            this.isError = true
            this.message = errorMessage
          }
        } catch(error) {
          this.isError = true
          console.log(error);
        }
      }
    },
    async mounted() {
      const { companyLogo } = await getCompanyLogo()
      this.logoEmpresa = companyLogo

      this.validRecoveryPassword(this.$route.query.K)
    },
    computed: {
      validateForm() {
        let isValid = false

        if (this.nuevaClave.length > 0 && this.confirmacionClave.length > 0) {
          if (this.nuevaClave === this.confirmacionClave) {
            isValid = true
          }
        }

        return isValid
      }
    }

  }
</script>
